// components/Login.js
import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  
  const { login, isLoading } = useApp();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    const result = await login(formData.email, formData.password);
    
    // if (result.success) {
      
    //   //navigate('/dashboard'); // Redirect to dashboard or home page
    // }
    if (result.success) {
        navigate('/brand-audit');   // was '/dashboard'
      } 
    
    else {
      setError(result.error);
    }
  };

  // return (
  //   <Container component="main" maxWidth="sm">
  //     <Box sx={{ marginTop: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
  //       <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
  //         <Typography component="h1" variant="h4" align="center" gutterBottom>
  //           Sign In
  //         </Typography>

  //         {error && (
  //           <Typography color="error" align="center" sx={{ mb: 2 }}>
  //             {error}
  //           </Typography>
  //         )}

  //         <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
  //           <TextField
  //             margin="normal"
  //             required
  //             fullWidth
  //             id="email"
  //             label="Email Address"
  //             name="email"
  //             autoComplete="email"
  //             autoFocus
  //             value={formData.email}
  //             onChange={handleChange}
  //             disabled={isLoading}
  //           />
  //           <TextField
  //             margin="normal"
  //             required
  //             fullWidth
  //             name="password"
  //             label="Password"
  //             type="password"
  //             id="password"
  //             autoComplete="current-password"
  //             value={formData.password}
  //             onChange={handleChange}
  //             disabled={isLoading}
  //           />
  //           <Button
  //             type="submit"
  //             fullWidth
  //             variant="contained"
  //             sx={{ mt: 3, mb: 2 }}
  //             disabled={isLoading}
  //           >
  //             {isLoading ? 'Signing In...' : 'Sign In'}
  //           </Button>
  //           <Box textAlign="center">
  //             <Link component={RouterLink} to="/register" variant="body2">
  //               {"Don't have an account? Sign Up"}
  //             </Link>
  //           </Box>
  //         </Box>
  //       </Paper>
  //     </Box> 
  //   </Container>
  // );
  return (
          <Container component="main" maxWidth="sm">
            <Box
              sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  padding: 4,
                  width: '100%',
                  borderRadius: '20px',
                  background: 'rgba(255,255,255,0.7)',
                  backdropFilter: 'blur(20px)',
                  border: '1px solid rgba(255,255,255,0.6)',
                  boxShadow: '0 8px 32px rgba(107,79,160,.15)'
                }}
              >
                <Typography
                  component="h1"
                  variant="h4"
                  align="center"
                  gutterBottom
                  sx={{
                    fontFamily: 'Fraunces, serif',
                    color: 'var(--ink)'
                  }}
                >
                  Sign In
                </Typography>

                {error && (
                  <Typography color="error" align="center" sx={{ mb: 2 }}>
                    {error}
                  </Typography>
                )}

                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Email Address"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={isLoading}
                  />

                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Password"
                    name="password"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                    disabled={isLoading}
                    autoComplete="current-password"
                  />

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={isLoading}
                    sx={{
                      mt: 3,
                      mb: 2,
                      backgroundColor: 'var(--thistle)',
                      borderRadius: '12px',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '15px',
                      boxShadow: '0 4px 16px rgba(107,79,160,.3)',
                      '&:hover': {
                        backgroundColor: '#5A3D8A',
                        boxShadow: '0 6px 20px rgba(107,79,160,.4)'
                      }
                    }}
                  >
                    {isLoading ? 'Signing In...' : 'Sign In'}
                  </Button>

                  <Box textAlign="center">
                    <Link
                      component={RouterLink}
                      to="/register"
                      sx={{
                        color: 'var(--thistle)',
                        textDecoration: 'none',
                        fontWeight: 500,
                        '&:hover': { textDecoration: 'underline' }
                      }}
                    >
                      Don't have an account? Sign Up
                    </Link>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Container>
        );
};

export default Login;